import lottie from 'lottie-web'

class Tutorial {
  constructor() {
    this.initialize()
  }

  initialize() {
    let $this = this;
    this.element = document.querySelector('.tutorial');
    this.elementLottie = this.element.querySelector('.js-tutorial');
    if(this.elementLottie.querySelectorAll('svg').length == 0) {
      lottie.loadAnimation({
        container: this.elementLottie,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: this.elementLottie.dataset.path
      });

      let $closes = this.element.querySelectorAll('.js-tutorial-close');
      for(let i = 0; i < $closes.length; i++) {
        $closes[i].addEventListener('click', $this.closeTutorial.bind(this))
        $closes[i].addEventListener('keydown', this.handleKeyDown.bind(this))
      }
    }
    this.element.classList.add('is-open');
    
    // Attendre que l'animation d'ouverture soit terminée avant de setup l'accessibilité
    setTimeout(() => {
      this.setupAccessibility();
    }, 1000);
  }

  setupAccessibility() {
    // Désactiver le focus sur tous les éléments sauf le tutorial
    const allFocusableElements = document.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
    allFocusableElements.forEach(el => {
      if (!el.closest('.tutorial')) {
        el.tabIndex = -1;
      }
    });

    // Activer le focus sur les éléments du tutorial
    const tutorialFocusableElements = this.element.querySelectorAll('button, [tabindex="0"]');
    tutorialFocusableElements.forEach(el => {
      el.tabIndex = 0;
    });

    // Focus sur le premier bouton de fermeture
    const firstCloseButton = this.element.querySelector('.js-tutorial-close');
    if (firstCloseButton) {
      firstCloseButton.focus();
    }

    // Sauvegarder les références pour le nettoyage
    this._allFocusableElements = allFocusableElements;
    this._tutorialFocusableElements = tutorialFocusableElements;
  }

  handleKeyDown(e) {
    if (e.key === 'Escape') {
      this.closeTutorial();
    }
    if (e.key === 'Tab') {
      const focusableElements = this.element.querySelectorAll('button, [tabindex="0"]');
      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      if (e.shiftKey && document.activeElement === firstElement) {
        e.preventDefault();
        lastElement.focus();
      } else if (!e.shiftKey && document.activeElement === lastElement) {
        e.preventDefault();
        firstElement.focus();
      }
    }
  }

  closeTutorial() {
    this.element.classList.remove('is-open');
    
    // Restaurer le focus sur tous les éléments
    if (this._allFocusableElements) {
      this._allFocusableElements.forEach(el => {
        el.tabIndex = 0;
      });
    }

    // Nettoyer les événements
    const $closes = this.element.querySelectorAll('.js-tutorial-close');
    for(let i = 0; i < $closes.length; i++) {
      $closes[i].removeEventListener('keydown', this.handleKeyDown.bind(this));
    }
  }
}

export default Tutorial
